
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import singleServiceTime from '@xt/client/experimental/server-time'
import { MixinsHomeClick } from '@xt/client/mixins/home'
import type { ShowCommoditySwiperConfig } from '@xt/client/types/home.d'

@Component({
  components: {}
})
export default class SectionItemThird extends Mixins(MixinsHomeClick) {
  @Prop() config: ShowCommoditySwiperConfig

  getIsClickDisable() {
    const { signUpStartTime } = this.config

    return singleServiceTime.serviceDate.isBefore(signUpStartTime)
  }

  get btnText() {
    const now = singleServiceTime.serviceDate

    const { signUpStartTime, startTime, signUpEndTime, endTime, voteStartTime, voteEndTime, assign } = this.config

    const signUpStartTimeMoment = this.moment(signUpStartTime)
    const signUpEndTimeMoment = this.moment(signUpEndTime)
    const voteStartTimeMoment = this.moment(voteStartTime)
    const voteEndTimeMoment = this.moment(voteEndTime)
    const endTimeMoment = this.moment(endTime)
    const startTimeMoment = this.moment(startTime)

    if (now.isBefore(signUpStartTimeMoment)) {
      return assign?.notStart || '报名未开始'
    } else if (now.isAfter(signUpStartTimeMoment) && now.isBefore(signUpEndTimeMoment)) {
      return assign?.inProgress || '正在报名'
    } else if (now.isAfter(signUpEndTimeMoment) && now.isBefore(startTimeMoment)) {
      return assign?.signupEnd || '报名已结束'
    } else if (now.isAfter(startTimeMoment) && now.isBefore(endTimeMoment)) {
      return assign?.inPrepare || '备展中'
    } else if (now.isAfter(endTimeMoment) && now.isBefore(voteStartTimeMoment)) {
      return assign?.prepareEnd || '备展结束'
    } else if (now.isAfter(voteStartTimeMoment) && now.isBefore(voteEndTimeMoment)) {
      return assign?.inVote || '投票中'
    } else {
      return assign?.inShow || '观展'
    }
  }

  handleOpen() {
    if (this.config.event) {
      this.onClickEvent(this.config.event)
      return
    }

    if (this.getIsClickDisable()) return

    window.open(`/commodity/${this.config.productId}`)
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
